import React from 'react';
import Relay from 'react-relay';
import mergeWith from 'lodash/mergeWith'
import pickBy from 'lodash/pickBy'

import Button from '../../components/Button';
import CircleTable from '../../components/CircleTable';
import { isValidEmailAddress } from '../../components/UserPanel';
import ValidateUserMutation from '../../mutations/User/ValidateUserMutation';
import UpdateUserMutation from '../../mutations/User/UpdateUserMutation';

const pageSize = 10;

class CircleList extends React.Component {

    state = {
        loading: false,
        hasNextPage: false,
        hasPreviousPage: false,
    }
    
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setState({
          loading: true,
        })
        this.props.relay.setVariables({
          next: true
        }, readyState => {
          if (readyState.done) {
            this.setState({
              loading: false
            })
          }
        })
    }

    componentWillReceiveProps(nextProps) {

        //if (this.state.loading) return false
    
        const hasNextPage = nextProps.viewer.next ? nextProps.viewer.next.pageInfo.hasPreviousPage : this.state.hasNextPage;
        const hasPreviousPage = nextProps.viewer.prev ? nextProps.viewer.prev.pageInfo.hasNextPage : this.state.hasPreviousPage;
        this.setState({
          hasNextPage,
          hasPreviousPage
        })
      }
    
    componentWillMount(){
        this.componentWillReceiveProps(this.props)
    }

    dataFetched = ({ done, aborted }) => {
        if (done || aborted)  {
          this.setState({ loading: false }, () => this.componentWillReceiveProps(this.props))
        }
    }
    
    nextPage() {
        const hasPreviousPage = true;
        const hasNextPage = false;
    
        const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
        const cursor = pageInfo.startCursor;
        this.setState({ hasPreviousPage, hasNextPage, loading: true })
        this.props.relay.setVariables({
          before: cursor,
          next: true,
          prev: false
        }, this.dataFetched);
    }
    
    prevPage() {
        const hasNextPage = true;
        const hasPreviousPage = false;
        const pageInfo = this.props.viewer.prev ? this.props.viewer.prev.pageInfo : this.props.viewer.next.pageInfo;
        const cursor = pageInfo.endCursor;
        this.setState({ hasPreviousPage, hasNextPage, loading: true })
        this.props.relay.setVariables({
          after: cursor,
          next: false,
          prev: true
        }, this.dataFetched);
    }
    
    assetEdges() {
        // get the next edges or the prev edges, or just get an empty array
        return (this.props.viewer ?
          (this.props.viewer.next ? this.props.viewer.next.edges :
            (this.props.viewer.prev ? this.props.viewer.prev.edges : []))
          : [])
    }

    onEditCircleClick = (item, index, event) => {
        if(item == this.props.location.state.circle){
            return;
        }
  
        let path = '/circles/edit/'+item.id;
        this.props.router.push({
          pathname : path,
          state :{
            relay:this.props.relay,
            edit: true,
          }
        })
      }
  
      onCircleClick = (item, index, event) => {
        
          if(item == this.props.location.state.circle){
              return;
          }

          let path = '/circles/edit/'+item.id;
          this.props.router.push({
              pathname : path,
              state :{
                  relay:this.props.relay,
                  edit: false,
              }
          })
      }
    render(){
        if (this.state.loading) return (<div>Loading...</div>)
        const prevButton = this.state.hasPreviousPage ? <button onClick={ this.prevPage.bind(this) }>Prev</button> : '';
        const nextButton = this.state.hasNextPage ? <button onClick={ this.nextPage.bind(this) }>Next</button> : '';

        const circles = this.assetEdges();
        
        let filter = this.props.location.state.filter;
        return (
            <div>
                <CircleTable
                    dataSource={circles}
                    filter={filter}
                    viewer={this.props.viewer}
                    onItemClick={this.onCircleClick}
                    onEditItemClick={this.onEditCircleClick}
                />
                {this.props.children}
                { prevButton } { nextButton }
            </div>
        )
    }
}


CircleList.propTypes = ({
    viewer: React.PropTypes.object.isRequired,
    relay: React.PropTypes.object.isRequired,
    children: React.PropTypes.node,
});

export default Relay.createContainer(CircleList, {
    initialVariables: {
      first: pageSize,
      last: pageSize,
      after: null,
      before: null,
      next: false,
      prev: false,
    },
  
    fragments: {
      viewer: (variables) => Relay.QL`
        fragment on Viewer {
          next: circles(last: $last, before: $before) @include(if: $next) {
            edges {
                node {
                id
                name
                description
                publicShortCode	
                type
                mode
                creation_status {
                    status
                    reason
                }
                owner {
                    id
                    pseudo
                    firstName
                    lastName
                }
                address {
                    address
                    country
                    city
                }
                sport {
                    sport {
                    name {
                        FR
                    }
                    }
                }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
          }
  
          prev: circles(first: $first, after: $after) @include(if: $prev) {
            edges {
                node {
                id
                name
                description
                publicShortCode	
                type
                mode
                creation_status {
                    status
                    reason
                }
                owner {
                    id
                    pseudo
                    firstName
                    lastName
                }
                address {
                    address
                    country
                    city
                }
                sport {
                    sport {
                    name {
                        FR
                    }
                    }
                }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
          }
        }
        `,
    }
  });


// WEBPACK FOOTER //
// ./src/pages/Circle/CirclesList.js